import React, { useContext } from "react";
import { RxCross2 } from "react-icons/rx";
import AppContext from "../../context/AppContext";
import CommonButton from "../common/CommonButton";

const DeletePermission = ({ isLoading, onClose, deleteFunction, onDeleteText }) => {
  const { theme } = useContext(AppContext);
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div
        className={`bg-white rounded-lg p-4 relative overflow-y-auto xl:w-1/4 lg:w-1/4 md:w-1/2 sm:w-1/2 xsm:w-1/2 w-full max-h-full   ${
          theme === "dark"
            ? "dark-mode border border-red-500"
            : theme === "high-contrast"
            ? "high-contrast"
            : ""
        }`}
      >
        <span
          className="absolute top-0 right-0 m-4 cursor-pointer text-gray-500"
          onClick={onClose}
        >
          <RxCross2 />
        </span>
        <h5 className="font-normal text-sm  text-wrap  text-center mt-10">
          {onDeleteText}
        </h5>
        <div className="flex justify-center mt-2 gap-3">
          {/* <button
            type="button"
            onClick={onClose}
            className="mt-6 px-4 py-2 bg-white border border-gray-500 text-black font-semibold rounded-md hover:bg-gray-200"
          >
            Cancel
          </button> */}

          <CommonButton onClick={onClose} variant="danger" className="mt-6">
            Cancel
          </CommonButton>

          {/* <button
            type="submit"
            className="mt-6 ml-4 px-4 py-2 bg-red-600 text-white rounded-md font-semibold hover:bg-red-700"
            onClick={deleteFunction}
          >
            Proceed
          </button> */}

          <CommonButton
            type="submit"
            className={`${isLoading ? "bg-opacity-60" : "bg-opacity-100"} mt-6`}
            onClick={deleteFunction}
            variant="success"
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : "Proceed"}
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default DeletePermission;
